import { FilesAction } from './files.actions';

export class FilesState {
    pending: boolean;
    error: null;
    logo: null;
    file: any;
}

export const initialGenericState: FilesState = {
    pending: false,
    error: null,
    logo: null,
    file: null
}

export function FilesReducer(state: FilesState = initialGenericState, action: any){

    switch (action.type) {
        case FilesAction.getFullFile:
            return { ...{}, ...state, ...{ pending: true, error: null } };
        case FilesAction.getFullFileSuccess:
            return { ...{}, ...state, ...{ pending: false, error: null } };
        case FilesAction.getFullFileError:
            return { ...{}, ...state, ...{ pending: false, error: action.payload } };

        case FilesAction.getBlobFile:
            return { ...{}, ...state, ...{ pending: true, error: null } };
        case FilesAction.getBlobFileSuccess:
            return { ...{}, ...state, ...{ pending: false, error: null, file: action.payload } };
        case FilesAction.getBlobFileError:
            return { ...{}, ...state, ...{ pending: false, error: action.payload } };

        case FilesAction.getLogoFile:
            return { ...{}, ...state, ...{ pending: true, error: null } };
        case FilesAction.getLogoFileSuccess:
            return { ...{}, ...state, ...{ pending: false, error: null, logo: action.payload } };
        case FilesAction.getLogoFileError:
            return { ...{}, ...state, ...{ pending: false, error: action.payload } };

        default:
            return state;
    }

}